<div class="overviewWrapper">
    <div [ngClass]="['trancheOverview',((activeDetails | async) === detailTypes.TrancheDetails) ? '' : 'hidden']"
         data-automation-e2e-selector="trancheOverviewCards">
        <muni-gameday-tranche-details
                [tranche]="selectedTranche | async"
                [viewType]="viewType | async"
                [showCloseButton]="false">
        </muni-gameday-tranche-details>
    </div>
    <div [ngClass]="['entity',((activeDetails | async) === detailTypes.EntityDetails) ? '' : 'hidden']">
        <muni-gameday-loading [visible]="isLoading | async">
            <muni-gameday-entity-order-detail
                    data-automation-e2e-selector="entityOrderDetail">
            </muni-gameday-entity-order-detail>
        </muni-gameday-loading>
    </div>
    <div [ngClass]="['overview',((activeDetails | async) === detailTypes.SummaryDetails) ? '' : 'hidden']"
         class="animate-switch">
        <div class="recentOrders"
             data-automation-e2e-selector="recentOrdersCard">
            <muni-gameday-loading [visible]="isLoading | async">
                <div class="cardContainer">
                    <muni-gameday-recent-orders>
                    </muni-gameday-recent-orders>
                </div>
            </muni-gameday-loading>
        </div>
        <div class="summary"
             data-automation-e2e-selector="summaryCard">
            <muni-gameday-loading [visible]="isLoading | async">
                <div class="cardContainer">
                    <muni-gameday-deal-summary-card>
                    </muni-gameday-deal-summary-card>
                </div>
            </muni-gameday-loading>
        </div>
        <div class="leaderboard"
             data-automation-e2e-selector="leaderbordCard">
            <muni-gameday-loading [visible]="isLoading | async">
                <div class="cardContainer">
                    <muni-gameday-top-orders-card>
                    </muni-gameday-top-orders-card>
                </div>
            </muni-gameday-loading>
        </div>
    </div>
</div>
